"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZENDESK_DEFAULT_URLS = void 0;
exports.getUrlConfig = getUrlConfig;
const types_1 = require("../sdk/types");
const flagr_1 = require("../flagr");
exports.ZENDESK_DEFAULT_URLS = {
    baseUrl: 'https://service.grover.com/hc/{locale}',
    pages: {
        [types_1.HelpCenterPage.Faq]: '/',
        [types_1.HelpCenterPage.RequestForm]: '/requests/new',
        [types_1.HelpCenterPage.ReportDamage]: '/articles/19916293812754-Damaged-products',
    },
};
let urls;
function getUrlConfig() {
    var _a;
    if (urls) {
        return urls;
    }
    const zendeskFlag = (0, flagr_1.getZendeskFlag)();
    urls = (_a = zendeskFlag === null || zendeskFlag === void 0 ? void 0 : zendeskFlag.variantAttachment) !== null && _a !== void 0 ? _a : exports.ZENDESK_DEFAULT_URLS;
    return urls;
}
//# sourceMappingURL=url-config.js.map